import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import { validateEnvironment } from "./lib/utils/environment";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { setPostHogInstance } from "../../lib/error-tracking";

if (
	import.meta.env.VITE_PUBLIC_POSTHOG_KEY &&
	import.meta.env.VITE_PUBLIC_POSTHOG_KEY !== "local-placeholder"
) {
	posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
		api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
		opt_out_capturing_by_default: true,
	});
	setPostHogInstance(posthog as any);
}

validateEnvironment();

// React.StrictMode renders components twice (on dev but not production) in order to detect any problems with your code and warn you about them (which can be quite useful).
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<React.StrictMode>
		<PostHogProvider client={posthog}>
			<RouterProvider router={router} />
		</PostHogProvider>
	</React.StrictMode>
);
